"use client";

import React from "react";
import { Info } from "lucide-react";
import { ResponsivePopover } from "@/components/ui/responsive-popover";
import { ACCESS_LEVEL_OPTIONS } from "@/lib/auth/access-levels";

/**
 * The "what do these access levels mean?" help affordance for the Grant / Edit
 * Contact Access form. Extracted out of GrantClientAccessModal so that file
 * doesn't grow while it's already over the 300-line budget.
 *
 * Desktop renders ResponsivePopover's Mantine popover, portalled to
 * document.body at z-index 1100 — it escapes the surrounding modal's overflow
 * context AND outranks the modal itself (Mantine modals are z-index 200), which
 * is why no z class is needed here. Mobile renders a drawer.
 */
export function AccessLevelInfoPopover() {
  return (
    <ResponsivePopover forcePopover
      content={
        <ul className="space-y-1">
          {ACCESS_LEVEL_OPTIONS.map((level) => (
            <li key={level.value} className="break-words">
              <b>{level.label}:</b> {level.description}
            </li>
          ))}
        </ul>
      }
      title="Access levels"
      popoverSide="right"
      align="start"
      className="max-w-[min(18rem,90vw)] text-xs"
      showCloseButton={false}
      asChild
    >
      <button
        type="button"
        aria-label="Access level explanations"
        className="inline-flex items-center justify-center rounded p-0.5 text-gray-400 hover:text-gray-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <Info className="h-4 w-4" />
      </button>
    </ResponsivePopover>
  );
}
